<template>
    <div class="traffic-main">
        <trafficBanner></trafficBanner>
        <trafficComponents></trafficComponents>
    </div>
</template>
<script>
import trafficBanner from '/components/pc/headerComponent/trafficBanner.vue'
import trafficComponents from '/components/pc/experience/trafficComponents.vue'
export default {
    components: {
        trafficBanner,
        trafficComponents
    },
    data() {
        return {
            
        }
    }
}
</script>
<style scoped lang="scss"> 
.traffic-main{
    width: 100%;
}
</style> 